<template>
  <div class="iftttNotice_option_left">
    <span class="iftttNotice_option_left_num">{{ num }}</span>
    <span class="iftttNotice_option_left_label">{{ label }}</span>
  </div>
</template>

<script>

export default {
  props: {
    num: {
      type: [ Number, String ],
      default: 1
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.iftttNotice_option_left {
      display: flex;
      width: 165px;
      align-items: center;

      &_num {
        width: 23px;
        height: 23px;
        border-radius: 50%;
        text-indent: 6px;
        color: #fff;
        background-color: #439af3;
        font-style: italic;
        line-height: 23px;
        font-style: italic;
      } 

      &_label {
        padding-left: 26px;
        font-size: 14px;
        font-weight: bold;
        color: #1d1d1d;
      }
    }
</style>
